/* KARISMAI theme behaviours — gallery, tabs, size guide, film, drawer */
(function () {
  'use strict';

  /* ---------- Hero banner carousel ---------- */
  function initHeroCarousel(el) {
    var slides = el.querySelectorAll('[data-kar-hero-slide]');
    if (slides.length < 2) return;
    var dots = el.querySelectorAll('[data-kar-hero-dot]');
    var idx = 0;
    var timer = null;
    var interval = (parseInt(el.getAttribute('data-interval'), 10) || 5) * 1000;
    var autoplay = el.hasAttribute('data-autoplay');

    function show(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (sl, i) { sl.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { show(idx + 1); }, interval);
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { show(i); play(); });
    });

    /* 页面加载完成后把其余幻灯片改为立即加载，避免切换时出现空白闪烁 */
    function preloadRest() {
      slides.forEach(function (sl, i) {
        if (i === 0) return;
        sl.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
      });
    }
    if (document.readyState === 'complete') preloadRest();
    else window.addEventListener('load', preloadRest);

    /* 移动端滑动切换 */
    var startX = null;
    el.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);
      startX = null;
      play();
    }, { passive: true });

    /* 标签页不可见时暂停 */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else play();
    });

    play();
  }

  /* ---------- Announcement ticker (无缝滚动) ---------- */
  function initMarquee(bar) {
    var track = bar.querySelector('[data-kar-marquee-track]');
    var group = track && track.querySelector('[data-kar-marquee-group]');
    if (!track || !group) return;

    function layout() {
      /* 先清掉上一次的克隆，保证重复调用（resize / 主题编辑器重载）不会累积 */
      while (track.children.length > 1) track.removeChild(track.lastChild);

      var groupW = group.getBoundingClientRect().width;
      var barW = bar.getBoundingClientRect().width;
      if (!groupW || !barW) return;

      /* 至少 2 组才能无缝衔接；不够宽就继续补，保证任何时刻画面都填满 */
      var groups = Math.max(2, Math.ceil(barW / groupW) + 1);
      for (var i = 1; i < groups; i++) {
        var clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-kar-marquee-group');
        /* 克隆里不保留主题编辑器的区块标记，避免编辑器选中错乱 */
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) {
          el.removeAttribute('data-shopify-editor-block');
        });
        track.appendChild(clone);
      }

      var speed = parseFloat(bar.getAttribute('data-speed')) || 55; /* px/s */
      track.style.setProperty('--kar-mq-groups', groups);
      track.style.setProperty('--kar-mq-dur', (groupW / speed).toFixed(2) + 's');
    }

    layout();

    if (bar.dataset.karMqReady !== '1') {
      bar.dataset.karMqReady = '1';
      var t = null;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(layout, 200);
      }, { passive: true });
      /* 自托管字体加载完成后宽度会变，重算一次 */
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(layout).catch(function () {});
      }
    }
  }

  /* ---------- Announcement roll-up（纵向轮换） ---------- */
  function initVTicker(bar) {
    var slides = bar.querySelectorAll('[data-kar-vslide]');
    if (slides.length < 2) {
      /* 只有一条时不轮换，直接摆正 */
      if (slides[0]) slides[0].style.transform = 'translateY(0)';
      return;
    }

    var dwell = parseInt(bar.getAttribute('data-dwell'), 10) || 4000;
    var idx = 0;
    var timer = null;

    /* animate=false 时先关掉过渡并强制回流，让「归位」这一步不产生动画 */
    function place(el, y, animate) {
      if (!animate) {
        el.style.transition = 'none';
        el.style.transform = 'translateY(' + y + ')';
        void el.offsetHeight;
        el.style.transition = '';
        return;
      }
      el.style.transform = 'translateY(' + y + ')';
    }

    slides.forEach(function (s, n) {
      place(s, n === 0 ? '0%' : '100%', false);
      s.setAttribute('aria-hidden', n === 0 ? 'false' : 'true');
    });

    function next() {
      var cur = slides[idx];
      var nxt = slides[(idx + 1) % slides.length];
      place(nxt, '100%', false); /* 先无动画放到下方待命 */
      place(cur, '-100%', true); /* 当前条向上滑出 */
      place(nxt, '0%', true); /* 下一条向上滑入 */
      cur.setAttribute('aria-hidden', 'true');
      nxt.setAttribute('aria-hidden', 'false');
      idx = (idx + 1) % slides.length;
    }

    function play() {
      stop();
      timer = setInterval(next, dwell);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (bar.dataset.karVtReady !== '1') {
      bar.dataset.karVtReady = '1';
      if (bar.hasAttribute('data-pause-hover')) {
        bar.addEventListener('mouseenter', stop);
        bar.addEventListener('mouseleave', play);
      }
      /* 标签页不可见时暂停，回来继续 */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else play();
      });
    }

    play();
  }

  /* ---------- Mobile navigation drawer ---------- */
  function initDrawer(root) {
    var drawer = root.querySelector('[data-kar-drawer]');
    if (!drawer) return;
    var openers = root.querySelectorAll('[data-kar-drawer-open]');
    var closers = drawer.querySelectorAll('[data-kar-drawer-close]');

    function open() {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      // 让悬浮头部临时去掉 transform，抽屉才能铺满视口
      document.documentElement.classList.add('kar-drawer-open');
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      document.documentElement.classList.remove('kar-drawer-open');
    }

    openers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
    closers.forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- Campaign film ---------- */
  function initFilm(section) {
    var btn = section.querySelector('[data-kar-play]');
    if (!btn) return;
    var video = section.querySelector('video');
    var host = section.querySelector('.kar-film');
    var embed = section.getAttribute('data-embed');

    btn.addEventListener('click', function () {
      if (video) {
        host.classList.add('is-playing');
        video.controls = true;
        video.play();
        return;
      }
      if (embed) {
        var frame = document.createElement('iframe');
        frame.src = embed + (embed.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        frame.setAttribute('allow', 'autoplay; fullscreen');
        frame.setAttribute('title', 'Campaign film');
        section.querySelector('.kar-film__media').appendChild(frame);
        host.classList.add('is-playing');
      }
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    var gallery = root.querySelector('[data-kar-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-kar-gallery-track]');
    if (!track) return;
    var cells = Array.prototype.slice.call(track.querySelectorAll('.kar-gallery__cell'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-kar-thumb]'));
    var thumbBox = gallery.querySelector('[data-kar-gallery-thumbs]');
    var counter = gallery.querySelector('[data-kar-gallery-count]');
    if (!cells.length) return;
    var current = 0;

    function mark(i) {
      current = i;
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
      });
      if (counter) counter.textContent = cells.length > 1 ? i + 1 + '/' + cells.length : '';
      /* 当前缩略图保持在缩略图列的可视范围内（只滚缩略图列，不滚页面） */
      var t = thumbs[i];
      if (t && thumbBox) {
        var top = t.offsetTop;
        var bottom = top + t.offsetHeight;
        if (top < thumbBox.scrollTop) thumbBox.scrollTop = top;
        else if (bottom > thumbBox.scrollTop + thumbBox.clientHeight) thumbBox.scrollTop = bottom - thumbBox.clientHeight;
      }
    }

    function go(i, instant) {
      if (i < 0 || i >= cells.length) return;
      var w = track.clientWidth;
      if (w) {
        track.scrollTo({ left: w * i, behavior: instant ? 'auto' : 'smooth' });
      }
      mark(i);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        go(parseInt(t.getAttribute('data-kar-thumb'), 10) || 0);
      });
    });

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var w = track.clientWidth;
          if (!w) return;
          var i = Math.round(track.scrollLeft / w);
          if (i !== current && i >= 0 && i < cells.length) mark(i);
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      go(current, true);
    });

    /* 颜色选择图等外部元素：data-kar-goto-media="序号" 点击后跳到对应图 */
    root.addEventListener('click', function (e) {
      var el = e.target.closest ? e.target.closest('[data-kar-goto-media]') : null;
      if (!el || !root.contains(el)) return;
      var i = parseInt(el.getAttribute('data-kar-goto-media'), 10);
      if (!isNaN(i)) go(i);
    });

    mark(0);
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-kar-tabs]').forEach(function (group) {
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[data-kar-tab]'));
      var panels = Array.prototype.slice.call(
        (group.closest('[data-kar-tabs-scope]') || root).querySelectorAll('[data-kar-panel]')
      );
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var name = tab.getAttribute('data-kar-tab');
          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-kar-panel') === name);
          });
        });
      });
    });
  }

  /* ---------- Size / colour option pickers ---------- */
  function initOptions(root) {
    var form = root.querySelector('[data-kar-product-form]');
    if (!form) return;
    var variants = [];
    var dataEl = root.querySelector('[data-kar-variants]');
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        variants = [];
      }
    }
    var idInput = form.querySelector('[data-kar-variant-id]');
    var addBtn = form.querySelector('[data-kar-add]');
    var priceEl = root.querySelector('[data-kar-price]');
    var sizeLabel = root.querySelector('[data-kar-size-label]');
    var colorValue = root.querySelector('[data-kar-color-value]');
    var selection = {};

    root.querySelectorAll('[data-kar-option]').forEach(function (el) {
      var pos = el.getAttribute('data-kar-option');
      if (el.classList.contains('is-selected')) selection[pos] = el.getAttribute('data-value');
      el.addEventListener('click', function () {
        if (el.classList.contains('is-unavailable')) return;
        root
          .querySelectorAll('[data-kar-option="' + pos + '"]')
          .forEach(function (sib) {
            sib.classList.toggle('is-selected', sib === el);
          });
        selection[pos] = el.getAttribute('data-value');
        update();
      });
    });

    function update() {
      if (sizeLabel && selection['1']) {
        sizeLabel.textContent = sizeLabel.getAttribute('data-prefix') + ' ' + selection['1'];
      }
      if (colorValue && selection['2']) colorValue.textContent = selection['2'];
      if (!variants.length) return;
      var match = variants.find(function (v) {
        return Object.keys(selection).every(function (pos) {
          return v.options[parseInt(pos, 10) - 1] === selection[pos];
        });
      });
      if (!match) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-unavailable') || 'Unavailable';
        }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? addBtn.getAttribute('data-default')
          : addBtn.getAttribute('data-soldout') || 'Sold out';
      }
    }

    update();
  }

  /* ---------- Size guide drawer ---------- */
  function initSizeGuide(root) {
    var guide = root.querySelector('[data-kar-sizeguide]');
    if (!guide) return;

    function open() {
      guide.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      guide.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-kar-sizeguide-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
    guide.querySelectorAll('[data-kar-sizeguide-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    // Unit toggle
    var units = Array.prototype.slice.call(guide.querySelectorAll('[data-kar-unit]'));
    units.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.getAttribute('data-kar-unit');
        units.forEach(function (u) {
          u.classList.toggle('is-active', u === btn);
        });
        guide.querySelectorAll('[data-in]').forEach(function (cell) {
          var v = parseFloat(cell.getAttribute(unit === 'cm' ? 'data-cm' : 'data-in'));
          cell.textContent = isNaN(v) ? cell.textContent : unit === 'cm' ? v.toFixed(1) : v.toFixed(2).replace(/0$/, '');
        });
        guide.querySelectorAll('[data-kar-unit-label]').forEach(function (l) {
          l.textContent = l.getAttribute('data-' + unit);
        });
      });
    });
  }

  /* ---------- 分类走马灯：左右箭头滚动 ---------- */
  function initCarousel(el) {
    if (el.dataset.karCarouselReady === '1') return;
    el.dataset.karCarouselReady = '1';

    var track = el.querySelector('[data-kar-carousel-track]');
    var prev = el.querySelector('[data-kar-carousel-prev]');
    var next = el.querySelector('[data-kar-carousel-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.kar-carousel__card');
      if (!card) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------- 页脚国家/货币切换：选完直接提交 ---------- */
  function initLocale(select) {
    if (select.dataset.karLocaleReady === '1') return;
    select.dataset.karLocaleReady = '1';
    select.addEventListener('change', function () {
      var form = select.closest('form');
      if (form) form.submit();
    });
  }

  /* ---------- Boot ---------- */
  /* ---------- 悬浮头部：公告栏 + 头部常驻顶部 ---------- */
  function initStickyHeader() {
    var announce = document.querySelector('.kar-announcement-section');
    var header = document.querySelector('.kar-header-section');
    /* PDP 购买区：高度写进 --kar-buy-h，供悬浮居中的 calc 使用 */
    var buy = document.querySelector('.kar-pdp__buy');
    if (!announce && !header && !buy) return;

    function measure() {
      var root = document.documentElement.style;
      if (announce) root.setProperty('--kar-announce-h', Math.round(announce.getBoundingClientRect().height) + 'px');
      if (header) root.setProperty('--kar-header-h', Math.round(header.getBoundingClientRect().height) + 'px');
      if (buy) root.setProperty('--kar-buy-h', Math.round(buy.getBoundingClientRect().height) + 'px');
    }

    measure();
    window.addEventListener('resize', measure, { passive: true });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(measure);
      if (announce) ro.observe(announce);
      if (header) ro.observe(header);
      if (buy) ro.observe(buy);
    }
  }

  /* ---------- 国家 / 货币选择器 ---------- */
  function initLocalePicker(root) {
    root.querySelectorAll('[data-kar-locale]').forEach(function (box) {
      if (box.dataset.karReady === '1') return;
      box.dataset.karReady = '1';
      var btn = box.querySelector('[data-kar-locale-toggle]');
      var panel = box.querySelector('[data-kar-locale-panel]');
      if (!btn || !panel) return;

      function close() {
        panel.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      }
      function open() {
        panel.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        var cur = panel.querySelector('.is-current');
        if (cur) cur.scrollIntoView({ block: 'nearest' });
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        panel.hidden ? open() : close();
      });
      document.addEventListener('click', function (e) {
        if (!box.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    });
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-kar-locale-select]').forEach(initLocale);
    initDrawer(root);
    initLocalePicker(root);
    initStickyHeader();
    initGallery(root);
    initTabs(root);
    initOptions(root);
    initSizeGuide(root);
    root.querySelectorAll('[data-kar-film]').forEach(initFilm);
    root.querySelectorAll('[data-kar-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-kar-hero-carousel]').forEach(initHeroCarousel);
    root.querySelectorAll('[data-kar-marquee]').forEach(initMarquee);
    root.querySelectorAll('[data-kar-vticker]').forEach(initVTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
